
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { RoleNameDDLAPI, WorkTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const RoleNameDataDDL = (props) => {
    const { Role, setRole, rowData, Flag, setDesignation, Designation, setEmployeeDDL, EmployeeDDL, M_ProjectTypeID } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token, M_ProjectTypeID }
        if (M_ProjectTypeID != 0) {
            dispatch(RoleNameDDLAPI({ data }))
        }
    }, [M_ProjectTypeID])

    const { RoleNameData } = useSelector(state => state.RoleNameDDLData)


    useEffect(() => {
        handleRoleDDL()
    }, [RoleNameData])

    const handleRoleDDL = () => {
        // console.log(DeptDDLDataa)
        if (RoleNameData && RoleNameData.table && RoleNameData.table.length > 0) {
            let list = RoleNameData.table.map((item, index) => ({
                value: item.id,
                label: item.role,
            }))

            setRole({
                DDL: list,
                // ID: Flag === 'Update' ? rowData.m_RoleID : 0,
                // Label: Flag === 'Update' ? rowData.m_RoleName : "Select...",
                ID: Flag === 'Update' ? rowData.m_RoleID : 0,
                Label: Flag === 'Update' ? rowData.role : "Select...",
            })
        }
        else {
            setRole({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofWorkType"><b>Role {Flag && <AstricSign />}</b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={150}
                value={{ value: Role.ID, label: Role.Label }}
                onChange={(e) => {
                    e ?
                        setRole({ ...Role, ID: e.value, Label: e.label })
                        :
                        setRole({ ...Role, ID: 0, Label: "Select..." })
                    setDesignation && setDesignation({ ...Designation, ID: 0, Label: "Select..." })
                    setEmployeeDDL && setEmployeeDDL({ ...EmployeeDDL, ID: 0, Label: "Select..." })

                }}
                options={Role.DDL}
            />

        </div>
    )
}